export default "__VITE_PUBLIC_ASSET__14644d77__"